import * as t from "react";
import { createTheme as e } from "@aws-amplify/ui";
const o = t.createContext({
  theme: e()
});
export { o as AmplifyContext };